import { jsPDF } from "jspdf";

function MyGradesExport(usuario, examenes) {
  //const doc = new jsPDF("p", "px", [793, 1122]);
  const doc = new jsPDF("p", "pt", [793, 1122]);
  //const doc = new jsPDF("p", "px", "A4");
  //const doc = new jsPDF('p', 'pt', [595.28,841.89]);

  const displayFormat = "DD/MM/YYYY";
  var moment = require("moment");

  let headerHtml = `<html><body style="font-family: sans-serif">
    <div style="border: 1px solid black; width: 350px; padding: 0 20px;margin-left: 50px;margin-top: 50px;">
    <table id="header" style="width: 100%">
        <tr>
            <td style="max-width: 33%; text-align: right;"><img src="aikido_caligrafia.png" alt="aikido-logo" style="width: 30px;"/></td>
            <td style="width: 100px; text-align: center;"><img src="faa-logo.jpg" alt="faa-logo" style="width: 64px;"/></td>
            <td style="max-width: 33%; text-align: left;font-size:20px; font-weight: bold;">AI<br/>KI<br/>DO</td>
        </tr>
    </table>
    <table id="subheader" style="width: 100%;">
            <tr>
                <td style="font-family: sans-serif;font-size: 11px;color: #2323ab;text-align: center;padding-bottom: 3px;border-bottom: solid 1px #2323ab;">Miembro de INTERNATIONAL AIKIDO FEDERATION (Japón)</td>
            </tr>
    </table>        
    <table id="student" style="width: 100%;margin-top: 20px">    
        <tr>
            <td style="text-align: left;width: 25%; color: #2323ab;">Apellido</td>
            <td style="text-align: left;font-weight: bold;font-family: sans-serif">${
              usuario.lastname
            }</td>
        </tr>
        <tr>
            <td style="text-align: left;color: #2323ab;">Nombre</td>
            <td style="text-align: left;font-weight: bold;font-family: sans-serif">${usuario.name.replaceAll(
              " ",
              "&nbsp;"
            )}</td>
        </tr>
        <tr>
            <td style="text-align: left;color: #2323ab;">D.N.I.</td>
            <td style="text-align: left;font-weight: bold;font-family: sans-serif">${
              usuario.docNumber
            }</td>
        </tr>
        <tr>
            <td style="text-align: left;color: #2323ab;">Ingreso</td>
            <td style="text-align: left;font-weight: bold;font-family: sans-serif">${moment(
              usuario.startDate
            ).format(displayFormat)}</td>
        </tr>
    </table>
    <table id="grades" style="width: 100%;margin-top: 10px">`;

  examenes.sort(function (a, b) {
    return moment(a.date).toDate() - moment(b.date).toDate();
  });

  const headerKyu = `<tr><td colspan=2 style="text-align: center;font-size: 18;background-color: #2323ab;color: white;height: 27;font-family: sans-serif">GRADUACION&nbsp; &nbsp; KYU</td></tr>`;
  const headerDan = `<tr><td colspan=2 style="text-align: center;font-size: 18;background-color: #2323ab;color: white;height: 27px;font-family: sans-serif">GRADUACION&nbsp; &nbsp; DAN</td></tr>`;

  let examsHtmlKyu = headerKyu;
  let examsHtmlDan = headerDan;
  examenes.map((exam) => {
    if (exam.grade.rank === "DAN") {
      examsHtmlDan =
        examsHtmlDan +
        "<tr><td style='text-align: center;background-color: #2323ab;color: white;height: 30px;'>" +
        exam.grade.name +
        "</td><td style='padding-left:20px;font-weight: bold;font-family: sans-serif'>" +
        moment(exam.date).format(displayFormat) +
        "  Nº " +
        exam.id +
        "</td></tr>";
    } else {
      examsHtmlKyu =
        examsHtmlKyu +
        "<tr><td style='text-align: center;background-color: #2323ab;color: white;height: 30px;'>" +
        exam.grade.name +
        "</td><td style='padding-left:20px;font-weight: bold;font-family: sans-serif'>" +
        moment(exam.date).format(displayFormat) +
        "  Nº " +
        exam.id +
        "</td></tr>";
    }
    return null;
  });
  examsHtmlKyu = examsHtmlKyu !== headerKyu ? examsHtmlKyu : "";
  examsHtmlDan = examsHtmlDan !== headerDan ? examsHtmlDan : "";

  let footerHtml = `</table>
    <p style="width: 100%;margin-top:5px;font-size: 10px;text-align: center;">El diploma de DAN esta registrado en el AIKIDO<br/> HOMBU DOJO, Tokio, Japón (Aikido World Headquarters)</p>
    </div></body></html>`;

  let carnetDigitalHtml = `${headerHtml}${examsHtmlKyu}${examsHtmlDan}${footerHtml}`;

  // let pWidth = doc.internal.pageSize.width; // 595.28 is the width of a4
  // let srcWidth = 800; //document.getElementById('idName').scrollWidth;
  // let margin = 18;
  // let scale = (pWidth - margin * 2) / srcWidth;

  doc.html(carnetDigitalHtml, {
    // x: margin,
    // y: margin,
    // html2canvas: {
    //     scale: SCALE,
    // },
    callback: () => {
      doc.save(`Carnet_Digital_FAA_${usuario.docNumber}.pdf`);
    },
  });
}

export default MyGradesExport;
